import { TranslateService } from '@ngx-translate/core';
import { RestService } from './../../services/rest.service';
import { GuiService } from 'src/app/services/gui.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'vex-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    public restService: RestService,
    public guiService: GuiService,
    @Inject(MAT_DIALOG_DATA) private item: any,
    private dialogRef: MatDialogRef<any>,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    setTimeout(() => this.guiService.showSpinner = false, 0)
    console.debug(this.item)
  }

  delete() {
    console.debug(this.item.type, this.item.id)
    if (this.guiService.userLogged.user.roles.includes('COLLAB') == false) {
      if(this.item.type ==='node-delete-trophy'){
        console.debug(this.item)
        this.restService.deleteService('node', '/delete-trophy/' + this.item.id, {}).subscribe((ris) => {
          this.dialogRef.close();
        })
      }
      if(this.item.type ==='remove-week-challenge'){
        this.restService.postService('node', '/remove-week-challenge', {
          userId: this.guiService.userLogged.user.id,
          index: this.item.id.index,
          challengeId: this.item.id.challengeId,
          challengeIndex: this.item.id.subChallengeIndex,
          weekIndex: this.item.id.weekIndex
        }).subscribe((ris) => {
          this.dialogRef.close();
        })
      }
      if(this.item.type ==='remove-sub-challenge'){
        this.restService.postService('node', '/remove-challenge-to-time-challenge', {
          userId: this.guiService.userLogged.user.id,
          index: this.item.id.index,
          challengeId: this.item.id.challengeId
        }).subscribe((ris) => {
          this.dialogRef.close();
        })
      }
      if(this.item.type ==='remove-challenge'){
        this.restService.postService('node', '/remove-challenge', {
          userId: this.guiService.userLogged.user.id,
          id: this.item.id
        }).subscribe((ris) => {
          this.dialogRef.close();
        })
      }
      if(this.item.type === 'node-delete-recipe'){
        this.restService.deleteService('node', '/delete-recipe/' + this.item.id, {}).subscribe((ris) => {
          this.dialogRef.close()
        })
      }
      if(this.item.type === 'node-delete-banner'){
        this.restService.deleteService('node', '/delete-banner/' + this.item.id, {}).subscribe((ris) => {
          this.dialogRef.close()
        })
      }
      if(this.item.type === 'node-delete-event'){
        this.restService.deleteService('node', '/delete-event/' + this.item.id, {}).subscribe((ris) => {
          this.dialogRef.close()
        })
      }
     else if (this.item.type !== 'deleteVideoCategory' && this.item.type !== 'remove-challenge' && this.item.type !== 'remove-sub-challenge' && this.item.type !== 'remove-week-challenge' && this.item.type !== 'node-delete-trophy') {
        this.restService.deleteService(this.item.type, '/' + this.item.id, {}).subscribe((ris) => {
          console.debug(ris)
          this.dialogRef.close()
        })
      }
    } else {
      window.alert("Questa operazione non è permessa, contattare l'amministratore.")
      this.dialogRef.close()
    }

  }

  close() {
    this.dialogRef.close('true')
  }

}
